<template>
    <div>
        <b-modal id="create-entity" title="Create a new entity" scrollable hide-footer>
            <div class="form-group">
                <label for="jobShow">Name</label>
                <input type="text" class="form-control" id="name" v-model="entitiesResource.attributes.name" />
                <label for="name">Legal Name</label>
                <input type="text" class="form-control" id="legal_name" v-model="entitiesResource.attributes.name_legal" />
                <label for="description">Name on Reports</label>
                <input type="text" class="form-control" id="name_reports" v-model="entitiesResource.attributes.name_reports" />
                <label for="description">Tax ID #</label>
                <input type="text" class="form-control" id="tin" v-model="entitiesResource.attributes.tin" />
                <label for="description">Parent Company</label>
                <auto-complete name="parent_id" attribute="parent_id" :resource-class="resources.EntitiesResource" :filter-options="{ entity_type_id: 1 }" @select="setParentId($event)">
                    <template slot="item" slot-scope="option">
                        <p>{{ option.item.name }}</p>
                    </template>
                </auto-complete>
                <label for="description">Propay ID</label>
                <input type="text" class="form-control" id="propay_id" v-model="entitiesResource.attributes.propay_id" />
                <label for="description">Apex Client</label>
                <input type="text" class="form-control" id="ext_payroll_id" v-model="entitiesResource.attributes.ext_payroll_id" />
                <label for="description">Apex Union Client</label>
                <input type="text" class="form-control" id="ext_payroll_union_id" v-model="entitiesResource.attributes.ext_payroll_union_id" />

                <div id="address_section" @change="addressChange()">
                    <label for="address1">ADDRESS LINE 1</label>
                    <address-auto-complete name="main_address1" :preSelectedValue="entitiesResource.attributes.main_address1" @select="addressAutoComplete"></address-auto-complete>
                    <div v-show="error_address1">
                        <p style="color:red;">{{ error_address1 }}</p>
                    </div>
                    <label for="address2">ADDRESS LINE 2</label>
                    <input type="text" class="form-control" id="main_address2" v-model="entitiesResource.attributes.main_address2" />
                    <label for="city">CITY*</label>
                    <input type="text" class="form-control" id="main_city" v-model="entitiesResource.attributes.main_city" />
                    <div v-show="error_city">
                        <p style="color:red;">{{ error_city }}</p>
                    </div>
                    <label for="state">STATE*</label>
                    <select class="form-control" id="state" v-model="state_id">
                        <option value="">Select One</option>
                        <option v-for="item of states" :value="item.attributes.id" :key="item.attributes.id">
                            {{ item.attributes.name }}
                        </option>
                    </select>
                    <div v-show="error_state">
                        <p style="color:red;">{{ error_state }}</p>
                    </div>
                    <label for="postal">POSTAL*</label>
                    <input type="text" class="form-control" id="main_postal" v-model="entitiesResource.attributes.main_postal" />
                    <div v-show="error_postal">
                        <p style="color:red;">{{ error_postal }}</p>
                    </div>
                    <label for="country">COUNTRY*</label>
                    <select class="form-control" id="main_country_id" v-model="entitiesResource.attributes.main_country_id">
                        <option value="1">United States</option>
                        <option value="2">Canada</option>
                        <option value="3">United Kingdom</option>
                        <option value="999">Other</option>
                    </select>
                </div>

                <label for="phone">Company</label>
                <select class="form-control" id="company_id" v-model="entitiesResource.attributes.company_id">
                    <option v-for="item in companyOptions" :value="item.value" :key="item.value"> {{ item.text }} </option>
                </select>
                <label for="mwCityOverride">Organization Type</label>
                <select class="form-control" id="org_type_id" v-model="entitiesResource.attributes.org_type_id">
                    <option v-for="item in orgTypeOptions" :value="item.value" :key="item.value"> {{ item.text }} </option>
                </select>
                <label for="mwPostalOverride">Entity Type</label>
                <select class="form-control" id="entity_type_id" v-model="entitiesResource.attributes.entity_type_id">
                    <option v-for="item in entityTypeOptions" :value="item.value" :key="item.value"> {{ item.text }} </option>
                </select>
                <label for="status">Industry Type</label>
                <select class="form-control" id="industry_type_id" v-model="entitiesResource.attributes.industry_type_id">
                    <option v-for="item in industryTypeOptions" :value="item.value" :key="item.value"> {{ item.text }} </option>
                </select>
                <label for="defaultValue">Default Pay Freq</label>
                <select class="form-control" id="pay_frequency_id" v-model="entitiesResource.attributes.pay_frequency_id">
                    <option v-for="item in payFrequencyTypeOptions" :value="item.value" :key="item.value"> {{ item.text }} </option>
                </select>
                <label for="defaultValue">Default Week Ending</label>
                <select class="form-control" id="week_ending_id" v-model="entitiesResource.attributes.week_ending_id">
                    <option v-for="item in defaultWeekEndingOptions" :value="item.value" :key="item.value"> {{ item.text }} </option>
                </select>
                <label for="defaultValue">Direct Deposit Enabled</label>
                <select class="form-control" id="dd_enabled" v-model="entitiesResource.attributes.dd_enabled">
                    <option v-for="item in booleanSelectOptions" :value="item.value" :key="item.value"> {{ item.text }} </option>
                </select>
                <label for="defaultValue">Harassment Certfication Enabled</label>
                <select class="form-control" id="certification_enabled" v-model="entitiesResource.attributes.certification_enabled">
                    <option v-for="item in booleanSelectOptions" :value="item.value" :key="item.value"> {{ item.text }} </option>
                </select>

                <label for="defaultValue">Show Budget</label>
                <input type="text" class="form-control" id="budget" v-model="entitiesResource.attributes.budget" />
                <label for="defaultValue">Principal Start Date</label>
                <input type="text" class="form-control" id="principal_start_date" v-model="entitiesResource.attributes.principal_start_date" />
                <label for="defaultValue">Principal End Date</label>
                <input type="text" class="form-control" id="principal_end_date" v-model="entitiesResource.attributes.principal_end_date" />
                <label for="defaultValue">Prep Start Date</label>
                <input type="text" class="form-control" id="prep_start_date" placeholder="YYYY-MM-DD" v-model="entitiesResource.attributes.prep_start_date" />
                <label for="defaultValue">Prep End Date</label>
                <input type="text" class="form-control" id="prep_end_date" placeholder="YYYY-MM-DD" v-model="entitiesResource.attributes.prep_end_date" />
                <label for="defaultValue">Post Start Date</label>
                <input type="text" class="form-control" id="post_start_date" placeholder="YYYY-MM-DD" v-model="entitiesResource.attributes.post_start_date" />
                <label for="defaultValue">Post End Date</label>
                <input type="text" class="form-control" id="post_end_date" placeholder="YYYY-MM-DD" v-model="entitiesResource.attributes.post_end_date" />

                <label for="defaultValue">Status</label>
                <select class="form-control" id="status" v-model="entitiesResource.attributes.status">
                    <option v-for="item in booleanSelectOptions" :value="item.value" :key="item.value"> {{ item.text }} </option>
                </select>
                <label for="defaultValue">Send Notifications</label>
                <select class="form-control" id="send_notifications" v-model="entitiesResource.attributes.send_notifications">
                    <option v-for="item in booleanSelectOptions" :value="item.value" :key="item.value"> {{ item.text }} </option>
                </select>

                <label for="defaultValue">Sick Policy</label>
                <select class="form-control" id="sick_policy_id" v-model="entitiesResource.attributes.sick_policy_id">
                    <option v-for="item in sickPolicyOptions" :value="item.value" :key="item.value"> {{ item.text }} </option>
                </select>
                <label for="defaultValue">Master Sick Company</label>
                <auto-complete
                    name="master_sick_entity"
                    attribute="master_sick_entity"
                    :resource-class="resources.EntitiesResource"
                    :filterOptions="{ entity_type_id: 1 }"
                    @select="setMasterSickEntity($event)"
                >
                    <template slot="item" slot-scope="option">
                        <p>{{ option.item.name }}</p>
                    </template>
                </auto-complete>
                <label for="defaultValue">Master Vacation Company</label>
                <auto-complete
                    name="master_vacation_entity"
                    attribute="master_vacation_entity"
                    :resource-class="resources.EntitiesResource"
                    :filter-options="{ entity_type_id: 1 }"
                    @select="setMasterVacationEntity($event)"
                >
                    <template slot="item" slot-scope="option">
                        <p>{{ option.item.name }}</p>
                    </template>
                </auto-complete>
                <label for="defaultValue">Master Holiday Company</label>
                <auto-complete
                    name="master_holiday_entity"
                    attribute="master_holiday_entity"
                    :resource-class="resources.EntitiesResource"
                    :filter-options="{ entity_type_id: 1 }"
                    @select="setMasterHolidayEntity($event)"
                >
                    <template slot="item" slot-scope="option">
                        <p>{{ option.item.name }}</p>
                    </template>
                </auto-complete>
                <div v-show="error_generic">
                    <br />
                    <p style="color:red">
                        <b-icon icon="exclamation-triangle-fill" variant="danger"></b-icon>&nbsp;{{ error_generic }}&nbsp;<b-button size="sm" @click="overrideAddress()">Yes, This is correct</b-button>
                    </p>
                </div>
                <div v-show="isAddressUpdated">
                    <br />
                    <p style="color:red">
                        <b-icon icon="exclamation-triangle-fill" variant="danger"></b-icon>&nbsp;Original address has been updated.&nbsp;<b-button size="sm" @click="overrideAddress()"
                            >Override</b-button
                        >
                    </p>
                </div>
                <div class="newUserButtonContainer">
                    <b-button @click="close()">Cancel</b-button>
                    <b-button @click="saveNewEntity">Save Company</b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<style scoped>
.newUserButtonContainer {
    display: flex;
    justify-content: space-between;
}
</style>

<script>
import Vue from 'vue'
// resources
import EntitiesResource from '../../resources/entities'
import AddressAutoComplete from '../../components/addressAutocomplete.vue'
import AutoComplete from '../../components/Autocomplete.vue'

// mixins
import modalMixin from '../../mixins/modal'
import toastMixin from '../../mixins/toast'

export default Vue.extend({
    props: {
        states: {
            required: false,
            type: Array,
        },
    },
    data() {
        return {
            entitiesResource: null,
            state_id: '',
            error_address1: '',
            error_city: '',
            error_state: '',
            error_postal: '',
            error_generic: '',
            isAddressChanged: false,
            isAddressUpdated: false,
            isAddressOverride: false,
            //states:{},

            booleanSelectOptions: [
                { value: 1, text: 'Enabled' },
                { value: 0, text: 'Disabled' },
            ],
            orgTypeOptions: [
                { value: 1, text: 'Corporation' },
                { value: 2, text: 'Sole-Proprietorship' },
                { value: 3, text: 'Individual' },
            ],
            entityTypeOptions: [
                { value: 1, text: 'Client' },
                { value: 2, text: 'Project' },
                { value: 3, text: 'Control Group' },
                { value: 4, text: 'Payroll Company' },
            ],
            industryTypeOptions: [
                { value: 1, text: 'N/A' },
                { value: 2, text: 'Entertainment' },
                { value: 3, text: 'Non-Entertainment' },
                { value: 4, text: 'Feature Film' },
                { value: 5, text: 'VideoTape' },
                { value: 6, text: 'Scripted Television' },
            ],
            payFrequencyTypeOptions: [
                { value: 1, text: 'WEEKLY' },
                { value: 2, text: 'BIWEEKLY' },
                { value: 3, text: 'SEMIMONTHLY' },
                { value: 4, text: 'MONTHLY' },
                { value: 5, text: 'DAILY' },
                { value: 6, text: 'QUARTERLY' },
            ],

            defaultWeekEndingOptions: [
                { value: 10, text: 'Saturday' },
                { value: 11, text: 'Sunday' },
                { value: 12, text: 'Monday' },
                { value: 13, text: 'Tuesday' },
                { value: 14, text: 'Wednesday' },
                { value: 15, text: 'Thursday' },
                { value: 16, text: 'Friday' },
            ],

            companyOptions: [{ value: 1, text: 'Revolution' }],

            countryOptions: [
                { value: 1, text: 'US' },
                { value: 2, text: 'Canada' },
                { value: 3, text: 'United Kingdom' },
                { value: 4, text: 'Other' },
            ],
            sickPolicyOptions: [
                { value: 85, text: 'Minimum by Law' },
                { value: 86, text: 'Employer/Company Policy In Place' },
                { value: 87, text: 'Frontload' },
                { value: 88, text: 'Exempt from Sick time' },
            ],
        }
    },
    components: {
        AddressAutoComplete,
        AutoComplete,
    },
    computed: {
        resources() {
            return {
                EntitiesResource,
            }
        },
    },
    mixins: [modalMixin, toastMixin],
    methods: {
        // Set defaults
        displayNewEntityForm() {
            this.showModal('create-entity')
        },
        setParentId(event) {
            if (event && event.id) {
                this.entitiesResource.attributes.parent_id = event.id
            } else {
                this.entitiesResource.attributes.parent_id = ''
            }
        },
        setMasterSickEntity(event) {
            if (event && event.id) {
                this.entitiesResource.attributes.master_sick_entity = event.id
            } else {
                this.entitiesResource.attributes.master_sick_entity = ''
            }
        },
        setMasterVacationEntity(event) {
            if (event && event.id) {
                this.entitiesResource.attributes.master_vacation_entity = event.id
            } else {
                this.entitiesResource.attributes.master_vacation_entity = ''
            }
        },
        setMasterHolidayEntity(event) {
            if (event && event.id) {
                this.entitiesResource.attributes.master_holiday_entity = event.id
            } else {
                this.entitiesResource.attributes.master_holiday_entity = ''
            }
        },
        close() {
            this.isAddressChanged = false
            this.isAddressUpdated = false
            this.isAddressOverride = false
            this.removeErrorMessage()
            this.closeModal('create-entity')
        },
        // address override
        overrideAddress() {
            this.removeErrorMessage()
            this.isAddressOverride = true
            this.isAddressUpdated = false
        },
        addressChange() {
            // remove existing error message and changed true
            if (!this.isAddressChanged) this.isAddressChanged = true
            this.removeErrorMessage()
        },
        removeErrorMessage() {
            if (this.error_generic) this.error_generic = ''
            if (this.error_address1) this.error_address1 = ''
            if (this.error_city) this.error_city = ''
            if (this.error_state) this.error_state = ''
            if (this.error_postal) this.error_postal = ''
        },
        addressAutoComplete(address) {
            if (typeof address === 'object') {
                let state = this.states.find((element) => element.attributes.code == address.address.prov)
                let stateId
                if (state) stateId = state.attributes.id
                else stateId = 66
                let countryId = address.address.country.toUpperCase() == 'US' ? 1 : 2
                // postGrid issue - because of zip+4 code, when we send date to postGrid, they return "corrected" as a status instead of "verify".
                let removedZip4 = address.address.pc.split('-')
                this.entitiesResource.attributes.main_address1 = address.address.address
                this.entitiesResource.attributes.main_city = address.address.city
                this.state_id = stateId
                this.entitiesResource.attributes.main_country_id = countryId
                this.entitiesResource.attributes.main_postal = removedZip4[0]
            } else {
                this.entitiesResource.attributes.main_address1 = address
            }
        },
        verify(address1, address2, city, state, postal, country) {
            // actual verification function
            return new Promise(function(resolve, reject) {
                if (address1.length === 0) {
                    return
                }

                let address = {
                    line1: address1,
                }

                if (address2) {
                    address.line2 = address2
                }
                if (city) {
                    address.city = city
                }
                if (state) {
                    address.provinceOrState = state
                }
                if (postal) {
                    address.postalOrZip = postal
                }
                if (country) {
                    address.country = country
                }
                var xhr = new XMLHttpRequest()
                xhr.open('POST', 'https://api.postgrid.com/v1/addver/verifications?includeDetails=true')
                xhr.setRequestHeader('Content-Type', 'application/json')
                if (process.env.VUE_APP_POSTGRID_API_KEY) {
                    xhr.setRequestHeader('X-API-KEY', process.env.VUE_APP_POSTGRID_API_KEY)
                }
                xhr.timeout = 15000
                xhr.onload = function() {
                    var resp = JSON.parse(xhr.responseText)
                    if (xhr.status === 200) {
                        resolve(resp.data)
                    } else {
                        reject(resp)
                    }
                }
                // late response
                xhr.ontimeout = function(e) {
                    reject()
                }
                xhr.send(JSON.stringify({ address }))
            })
        },
        async verifyFields(address1, address2, city, state, postal, country) {
            if (!address1) {
                return false
            }
            // we want to separate suite number and key into line 2
            // postgrid provide line 1 with suite number and key
            let line2CustomString = ''

            try {
                if (state) state = this.states.find((element) => element.attributes.id == state).attributes.code
                if (country) country = country == 1 ? 'US' : 'CA'
                let result = await this.verify(address1, address2, city, state, postal, country)
                if (result.line1) address1 = result.line1

                if (result.zipPlus4) {
                    result.postalOrZip = result.postalOrZip ? result.postalOrZip + '-' + result.zipPlus4 : result.zipPlus4
                }
                if (result.urbanization) {
                    result.line2 = result.line2 ? result.line2 + ' URB ' + result.urbanization : result.urbanization
                }
                if (result.line2) address2 = result.line2
                if (result.details.suiteKey && result.details.suiteID) {
                    if (country == 1 || country.toUpperCase() == 'US') {
                        address1 = address1.split(result.details.suiteKey)[0];
                        line2CustomString = result.line2 ? result.line2 + ' ' + result.details.suiteKey + ' ' + result.details.suiteID : result.details.suiteKey + ' ' + result.details.suiteID;
                        address2 = line2CustomString;
                    }
                }
                if (result.city) city = result.city
                if (result.provinceOrState) {
                    state = this.states.find((element) => element.attributes.code == result.provinceOrState.toUpperCase())
                    if (!state) result.status = 'falied'
                    else state = state.id
                }
                if (result.postalOrZip) postal = result.postalOrZip
                if (result.country) {
                    country = result.country.toUpperCase() == 'US' ? 1 : 2
                }

                if (result.status === 'verified' || result.status === 'corrected') {
                    // insert data
                    this.entitiesResource.attributes.main_address1 = address1
                    this.entitiesResource.attributes.main_address2 = address2
                    this.entitiesResource.attributes.main_city = city
                    this.state_id = state
                    this.entitiesResource.attributes.main_country_id = country
                    this.entitiesResource.attributes.main_postal = postal
                    if (result.status === 'corrected') this.isAddressUpdated = true
                    return true
                } else {
                    if (result.errors) {
                        // handle errors
                        if (result.errors.line1) this.error_address1 = result.errors.line1
                        if (result.errors.city) this.error_city = result.errors.city
                        if (result.errors.provinceOrState) this.error_state = result.errors.provinceOrState
                        if (result.errors.postalOrZip) this.error_postal = result.errors.postalOrZip
                        this.error_generic = 'Address may not be valid'
                    }
                    return false
                }
            } catch (err) {
                this.error_generic = 'Address may not be valid'
                return false
            }
        },
        async saveNewEntity() {
            this.entitiesResource.attributes.main_state_id = this.state_id
            let errors = this.entitiesResource.validate()

            if (errors.length) {
                this.handleErrors(errors)
            } else {
                let verifyRes = true
                if (process.env.VUE_APP_ADDRESS_VALIDATION === 'true') {
                    if (this.error_generic) verifyRes = false
                    if (this.isAddressUpdated) this.isAddressUpdated = false
                    if (this.isAddressChanged && this.entitiesResource.attributes.main_state_id != 66 && verifyRes && !this.isAddressOverride && this.entitiesResource.attributes.main_address1) {
                        verifyRes = await this.verifyFields(
                            this.entitiesResource.attributes.main_address1,
                            this.entitiesResource.attributes.main_address2,
                            this.entitiesResource.attributes.main_city,
                            this.entitiesResource.attributes.main_state_id,
                            this.entitiesResource.attributes.main_postal,
                            this.entitiesResource.attributes.main_country_id
                        )
                        if (verifyRes) this.isAddressChanged = false
                    }
                }

                if (verifyRes == true) {
                    // do nothing
                } else {
                    this.createToast('b-toaster-top-center', 'danger', true, 'Error', 'Please check address fields before submitting')
                    return false
                }
                try {
                    const result = await this.entitiesResource.save()
                    if (result.response.status === 200 || result.response.status === 201) {
                        this.createToast('b-toaster-top-center', 'success', true, 'Entity Created', 'Entity Created')
                        if (!this.isAddressUpdated) this.closeModal('create-entity')
                    }
                } catch (error) {
                    this.createToast('b-toaster-top-center', 'danger', true, 'Entity Creation Error', 'Entity Creation Error')
                    throw error
                }
            }
        },
    },
    created() {
        this.entitiesResource = new EntitiesResource()
        this.entitiesResource.set('status', '1')
        this.entitiesResource.set('company_id', '1')
        this.entitiesResource.set('org_type_id', '1')
        this.entitiesResource.set('entity_type_id', '1')
        this.entitiesResource.set('industry_type_id', '2')
        this.entitiesResource.set('pay_frequency_id', '1')
        this.entitiesResource.set('week_ending_id', '10')
        this.entitiesResource.set('main_country_id', '1')
        this.entitiesResource.set('sick_policy_id', '86')
        this.entitiesResource.set('send_notifications', '1')
        this.entitiesResource.set('certification_enabled', '0')
        this.entitiesResource.set('dd_enabled', '1')
        this.entitiesResource.set('other_properties', '{}')
    },
})
</script>
